'use client';

import { c as _c } from "react/compiler-runtime";
import { AcceptTerms } from '@/components/selfservices/AcceptTerms';
import { LoginForm } from '@/components/selfservices/LoginForm';
import { Step, Steps } from '@/components/selfservices/Steps';
import { GuidelinesStepUnlock } from '@/components/selfservices/UnlockGuidelines';
import { useState } from 'react';
export const SSOSelfServiceInitatorUnlock = t0 => {
  const $ = _c(15);
  const {
    steps
  } = t0;
  const [currentStep, setCurrentStep] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setCurrentStep(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleNextStep = t1;
  let t2;
  if ($[1] !== currentStep || $[2] !== steps) {
    t2 = <div className="my-2 flex justify-center"><Steps steps={steps} currentStep={currentStep} /></div>;
    $[1] = currentStep;
    $[2] = steps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== currentStep) {
    t3 = currentStep === 0 && <AcceptTerms onAccepted={handleNextStep} />;
    $[4] = currentStep;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentStep) {
    t4 = currentStep === 1 && <GuidelinesStepUnlock onAccepted={handleNextStep} />;
    $[6] = currentStep;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== currentStep) {
    t5 = currentStep === 2 && <LoginForm />;
    $[8] = currentStep;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <>{t2}{t3}{t4}{t5}</>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(prevStep) {
  return prevStep + 1;
}